<div class="common-model-nav">
  <div class="height-separater">
    <div class="stk-back-btn"></div>
    <div class="stk-nav">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" style="margin-bottom: 0px;padding-top: 3.5%;">
          <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            @if (!showOnlyShareTab) {
            <a [routerLink]="['/maintenance/group']">Group Maintenance</a>
            } @if (showOnlyShareTab) {
            <a [routerLink]="['/my-downloads']">My Downloads</a>
            }
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ showOnlyShareTab ? 'Edit My Downloads' : 'Edit App Group' }}
          </li>
        </ol>
      </nav>
    </div>
  </div>
</div>

<div class="lob-model-view edit-group">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header">
        <span class="stk-c-header stk-container-header">
          <span class="stk-title">
            <span class="stk-header-title">{{ showOnlyShareTab ? 'Edit My Downloads' : 'Edit App Group' }}</span>
          </span>
        </span>
        @if (!showOnlyShareTab) {
        <span class="stk-c-header stk-container-header" style="float: right; padding-right:2.32%;cursor: pointer;">
          <i (click)="showpopup()" class="uitk-icon uitk-icon-info_hollow health"></i>
        </span>
        } @if (created_at) {
        <span class="stk-c-header stk-container-header" style="float: right; padding-right:2.32%;">
          Created on: <strong>{{ created_at | date: 'mediumDate' }}</strong>
          @if (updated_at) {
          <span>
            Updated On: <strong>{{ updated_at | date: 'mediumDate' }}</strong></span
          >
          }
        </span>
        }
      </div>
      <hr />
      <form
        name="form"
        class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12"
        #f="ngForm"
        novalidate
      >
        <div class="row ps-15 pe-15">
          <div class="uitk-l-grid__col--12" style="padding: 0;margin-bottom: -40px;">
            <div
              class="pull-right"
              style="    float: right;
            position: absolute;
            right: 0;
            z-index: 99999999;"
            ></div>
          </div>
          <div class="uitk-l-grid__col--12">
            <mat-tab-group (selectedTabChange)="tabchange($event, f)" [selectedIndex]="Activetab">
              @if (!showOnlyShareTab) {
              <mat-tab label="Details">
                <div
                  class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 ps-15, pe-15"
                >
                  <div class="form-check-inline form-flex-start d-inline-flex">
                    <div [ngClass]="{ 'has-error': f.submitted && groupname == '' }">
                      <span class="opid form-inline" for="groupname">
                        <p style="color: #013b71;font-weight: bold;">App Group Name <b class="text-danger">*</b></p>
                        <p>(up to 60 characters)</p>
                      </span>
                      <mat-form-field class="data-filter" appearance="outline" style="width: 440px">
                        <input
                          (input)="focusgp()"
                          [(ngModel)]="groupname"
                          name="groupname"
                          matInput
                          type="text"
                          maxlength="60"
                          (blur)="groupname = groupname.trim(); focusgp()"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </mat-form-field>
                      @if (f.submitted && groupname=='') {
                      <div class="help-block uitk-c-input__message--error">
                        App Group name is required
                      </div>
                      } @if (limitExccedgp) {
                      <div class="help-block uitk-c-input__message--error">
                        Only 60 characters allowed in App Group Name
                      </div>
                      } @if (oldGroupName !== groupname && groupname.length!=60) {
                      <div class="help-block uitk-c-input__message--error" style="background-color:green;">
                        <span> {{ 60 - groupname.length }} Char Left </span>
                      </div>
                      } @if (limitExhaust) {
                      <div class="help-block uitk-c-input__message--error">
                        O Char Left
                      </div>
                      }
                    </div>
                    <div style="padding-left: 1.36%;">
                      <span class="opid form-inline" for="groupname">
                        <p style="color: #013b71;font-weight: bold;">App Group Type</p>
                      </span>
                      <section class="tp-section">
                        <mat-form-field appearance="outline">
                          <mat-label>Custom</mat-label>
                          <mat-select
                            (keydown)="$event.stopPropagation()"
                            (selectionChange)="onGroupTypeChanged($event)"
                            [(ngModel)]="groupType"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="!isAdminRole"
                            panelClass="overlay-width-group"
                          >
                            @for (groupType of groupTypeList; track groupType) {
                            <mat-option class="edit-group-mat-option" [value]="groupType">
                              {{ groupType }}
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </section>
                    </div>
                    <div style="padding-left: 1.36%;" class="visibility">
                      <span class="opid form-inline" for="groupname">
                        <p style="color: #013b71;font-weight: bold;">Visibility</p>
                      </span>
                      <div class="visibility-radio-block">
                        <div class="visibility-radio-btn">
                          <input
                            style="height:15px; width:15px;"
                            type="radio"
                            name="imgsel"
                            value="Private"
                            [checked]="visibility === 'Private'"
                            (change)="onItemChange($event.target.value)"
                            [disabled]="groupType === 'Custom'"
                          />
                          <label
                            style="color: black;font-weight:lighter;font-size:small;font-family: 'UHCSans-Regular', 'Arial Regular';"
                            >Private</label
                          >
                        </div>
                        <div class="visibility-radio-btn">
                          <input
                            [checked]="visibility === 'Public'"
                            style="height:15px; width:15px; padding-left: 15px;"
                            type="radio"
                            name="imgsel"
                            value="Public"
                            (change)="onItemChange($event.target.value)"
                            [disabled]="groupType === 'Custom'"
                          />
                          <label
                            style="color: black;font-weight: lighter;font-size:small;font-family: 'UHCSans-Regular', 'Arial Regular';"
                            >Public</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-check-inline d-inline-flex form-edit-group-detail-page">
                    <div class="description-block">
                      <span class="opid form-inline" for="Description">
                        <p style="color: #013b71;font-weight: bold;">Description <b class="text-danger">*</b></p>
                        <p>(up to 300 characters)</p>
                      </span>
                      <textarea
                        (input)="focusDes()"
                        style="font-family: 'Arial Regular'; width: 440px; height: 100px;"
                        type="textarea"
                        class="form-control"
                        name="Description"
                        [(ngModel)]="Description"
                        required
                        minlength="3"
                        maxlength="300"
                        (blur)="Description = Description.trim(); focusDes()"
                        [ngModelOptions]="{ standalone: true }"
                      ></textarea>
                      @if (f.submitted && Description=='') {
                      <div class="help-block uitk-c-input__message--error">
                        Description is required
                      </div>
                      } @if (limitExcced) {
                      <div class="help-block uitk-c-input__message--error">
                        Only 300 characters allowed in Description
                      </div>
                      } @if (limitExhaustDes) {
                      <div class="help-block uitk-c-input__message--error">
                        0 Char Left
                      </div>
                      } @if (oldDescription !== Description && Description.length!=300) {
                      <div class="help-block uitk-c-input__message--error" style="background-color:green;">
                        <span> {{ 300 - Description.length }}Char Left </span>
                      </div>
                      }
                    </div>
                    <div
                      class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2"
                      style="padding-left:39.80%;padding-top: 4.97%;box-sizing: content-box;"
                    >
                      <button
                        class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                        mat-mdc-raised-button
                        style="margin-top: 15.17%;"
                        (click)="update_group(f)"
                        [disabled]="disableApply"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </mat-tab>
              } @if (!showOnlyShareTab) {
              <mat-tab label="Manage Applications">
                @if (showLoader) {
                <div class="stk-table-loader">
                  <app-loader> </app-loader>
                </div>
                } @if (!showLoader) {
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex"
                >
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                    <span class="opid form-inline" for="selectBy">
                      <p style="color: #013b71;font-weight: bold;">Select By</p>
                    </span>
                    <section class="tp-section">
                      <mat-form-field appearance="outline">
                        <mat-select
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onSelectByChanged($event)"
                          [(ngModel)]="selectBy"
                          [ngModelOptions]="{ standalone: true }"
                          panelClass="overlay-width-group"
                        >
                          @for (selectType of selectTypeList; track selectType) {
                          <mat-option class="edit-group-mat-option" [value]="selectType">
                            {{ selectType }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                  </div>
                  @if (selectBy === 'LOB') {
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                    <span class="opid form-inline" for="groupname">
                      <p style="color: #013b71;font-weight: bold;">LOB</p>
                    </span>
                    <section class="tp-section">
                      <mat-form-field appearance="outline">
                        <mat-select
                          multiple
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onCIOChanged()"
                          [(ngModel)]="SelectedCIO"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <input
                            (keydown)="$event.stopPropagation()"
                            matinput
                            type="text"
                            class="searchoption"
                            [(ngModel)]="CIO"
                            placeholder="Search"
                            [ngModelOptions]="{ standalone: true }"
                            (blur)="resetInputForLob()"
                          />
                          @for (cio of cioList | filter: CIO: 'noinsidecheck'; track cio) {
                          <mat-option class="edit-group-mat-option" [value]="cio">
                            {{ cio.name }}
                          </mat-option>
                          } @if (SelectedCIO && SelectedCIO.length > 0) {
                          <div>
                            @for (lob of SelectedCIO; track lob) { @if (checkWhetherCioIncludes(lob)) {
                            <mat-option class="display-none" [value]="lob">
                              {{ lob.name }}
                            </mat-option>
                            } }
                          </div>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                  </div>
                  } @if (selectBy === 'LOB') {
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                    <span class="opid form-inline" for="groupname">
                      <p style="color: #013b71;font-weight: bold;">Sub-LOB</p>
                    </span>
                    <section class="tp-section">
                      <mat-form-field appearance="outline">
                        <mat-select
                          multiple
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onLOBChanged()"
                          [(ngModel)]="SelectedLob"
                          [ngModelOptions]="{ standalone: true }"
                          #selector
                          [disabled]="disabled"
                        >
                          <input
                            (keydown)="$event.stopPropagation()"
                            matinput
                            type="text"
                            class="searchoption"
                            [(ngModel)]="LOB"
                            placeholder="Search"
                            [ngModelOptions]="{ standalone: true }"
                            (blur)="resetInputForSubLob()"
                          />
                          @for (lob of lobLists | filter : LOB; track lob) {
                          <mat-option class="edit-group-mat-option" [value]="lob">
                            <mat-label>{{ lob.subLob_name }}</mat-label>
                          </mat-option>
                          } @if (SelectedLob && SelectedLob.length > 0) {
                          <div>
                            @for (subLob of SelectedLob; track subLob) { @if (checkWhetherSubLobIncludes(subLob)) {
                            <mat-option class="display-none" [value]="subLob">
                              {{ subLob.subLob_name }}
                            </mat-option>
                            } }
                          </div>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                  </div>
                  } @if (selectBy === 'Bulk Upload') {
                  <div class="col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5 bulk-upload-block">
                    @if (selectBy == 'Bulk Upload') {
                    <section class="bulk-upload-download d-flex">
                      <span class="bulk-upload-download-txt">
                        <a [href]="Filepath" download>
                          Download Template
                        </a>
                      </span>
                      <span class="">
                        <input
                          type="file"
                          #fileInput
                          id="uploadFile"
                          (change)="uploadFileEvt($event.target.files)"
                          name="uploadFile"
                          accept=".xlsx"
                        />
                      </span>
                    </section>
                    }
                  </div>
                  } @if (selectBy !== 'LOB' && selectBy !== 'Bulk Upload') {
                  <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3">
                    @if (selectBy == 'SLO Owner') {
                    <section class="tp-section">
                      <span class="opid form-inline" for="groupname">
                        <p style="color: #013b71;font-weight: bold;">SLO</p>
                      </span>
                      <mat-form-field appearance="outline">
                        <mat-label><label class="label-alignment"> Search SLO Owner by Name </label></mat-label>
                        <mat-select
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onSloOwnerChanged($event)"
                          [(ngModel)]="selectedsloOwner"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <input
                            (keydown)="$event.stopPropagation()"
                            matinput
                            type="text"
                            class="searchoption"
                            [(ngModel)]="FSLO"
                            placeholder="Search SLO Owner by Name"
                            [ngModelOptions]="{ standalone: true }"
                            (blur)="resetInputForSloOwner()"
                          />
                          @for (owner of sloOwner | filtergrp: FSLO:sloOwnerCache; track owner) {
                          <mat-option class="edit-group-mat-option" [value]="owner.name">
                            {{ owner.name }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                    } @if (selectBy == 'Technical Owner') {
                    <section class="tp-section">
                      <span class="opid form-inline" for="groupname">
                        <p style="color: #013b71;font-weight: bold;">Technical Owner</p>
                      </span>
                      <mat-form-field appearance="outline">
                        <mat-label><label class="label-alignment"> Search Technical Owner by Name </label></mat-label>
                        <mat-select
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onTecOwnerChanged($event)"
                          [(ngModel)]="selctedTecOwner"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <input
                            (keydown)="$event.stopPropagation()"
                            matinput
                            type="text"
                            class="searchoption"
                            [(ngModel)]="Fowner"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Search Technical Owner by Name"
                            (blur)="resetInputForTechnicalOwner()"
                          />
                          @for (owner of tecOwner | filtergrp: Fowner:techOwnerCache; track owner) {
                          <mat-option class="edit-group-mat-option" [value]="owner.name">
                            {{ owner.name }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                    }
                  </div>
                  } @if (selectBy !== 'Bulk Upload') {
                  <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
                    <span class="opid form-inline" for="groupname">
                      <p style="color: #013b71;font-weight: bold;">Application <b class="text-danger">*</b></p>
                    </span>
                    <section class="tp-section">
                      <mat-form-field appearance="outline">
                        <mat-select
                          (keydown)="$event.stopPropagation()"
                          (selectionChange)="onAplicationValueChanged($event)"
                          [(ngModel)]="selectedApplicationName"
                          class="virtual-scroll"
                          multiple
                          #filterSelect="ngModel"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <input
                            (keydown)="$event.stopPropagation()"
                            matinput
                            type="text"
                            class="searchoption"
                            [(ngModel)]="FAVC"
                            [ngModelOptions]="{ standalone: true }"
                            (keyup)="OnFilterApp()"
                            placeholder="Search Application by Name or ID(min 3 Char)"
                            (blur)="resetInputValueForApplication()"
                          />
                          <div class="select-all">
                            @if (multiAppSelectAll && (appList).length>0) {
                            <input
                              id="appSelectAll"
                              [(ngModel)]="selectAll"
                              class="checkboxstyle"
                              type="checkbox"
                              (click)="selectAllAppName(checkAll.checked, filterSelect, appList)"
                              [ngModelOptions]="{ standalone: true }"
                              #checkAll
                            />
                            } @if (multiAppSelectAll && (appList).length>0) {
                            <span class="checkbox-inline">Select All</span>
                            }
                          </div>
                          @for (application of appList; track application) {
                          <mat-option
                            class="edit-group-mat-option"
                            [disabled]="application.disable"
                            title="{{ application.LONG_APP_NAME }}"
                            [value]="application"
                            (click)="appSelect()"
                          >
                            <span>
                              <span style="font-weight: bolder;">{{
                                application['App Lifecycle_Status'] === 'NON AIDE Specific'
                                  ? 'N - '
                                  : application['App Lifecycle_Status'] === 'In Development'
                                  ? 'Dev - '
                                  : application['App Lifecycle_Status'] === 'Production'
                                  ? 'P - '
                                  : application['App Lifecycle_Status'] === 'Decommissioned'
                                  ? 'D - '
                                  : 'NM - '
                              }}</span>
                              <span style="font-weight: bolder;">{{ application.ASK_GLOBAL_ID }}</span>
                              {{ application.LONG_APP_NAME }}</span
                            >
                          </mat-option>
                          } @if (selectedApplicationName && selectedApplicationName.length > 0) {
                          <div>
                            @for (appOpt of selectedApplicationName; track appOpt) { @if
                            (checkWhetherAppNameIncludes(appOpt)) {
                            <mat-option class="display-none" [value]="appOpt">
                              {{ appOpt.LONG_APP_NAME }}
                            </mat-option>
                            } }
                          </div>
                          }
                        </mat-select>
                      </mat-form-field>
                    </section>
                  </div>
                  }
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2 add-application">
                    <button
                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                      mat-mdc-raised-button
                      [disabled]="disableAdd"
                      (click)="update_group(f)"
                    >
                      Add
                    </button>
                  </div>
                </div>
                }
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex form-edit-group-manage-search"
                >
                  <ng-container>
                    <div class="table-search col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5 offset-md-6">
                      <mat-form-field class="data-filter" appearance="outline">
                        <input
                          matInput
                          type="text"
                          class="capability-search"
                          placeholder="Search Application"
                          (keyup)="searchDataSet($event)"
                        />
                        <img
                          src="../../../../assets/images/searchicon.png"
                          style="position: absolute;
                                                      right: 0px;
                                                      top: 20%;width:1.2rem"
                        />
                      </mat-form-field>
                    </div>
                    <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-1">
                      <ng-container>
                        <button
                          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                          mat-mdc-raised-button
                          style="margin-bottom: 18px;"
                          [disabled]="disableRemove"
                          (click)="removegroupapp()"
                        >
                          Remove
                        </button>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div class="row"></div>
                <div class="container">
                  <table
                    matSort
                    mat-table
                    [dataSource]="dataSource"
                    class="mat-elevation-z8"
                    (matSortChange)="sortData($event)"
                  >
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef style="width:3%;">
                        <mat-checkbox
                          (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                        >
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let row" style="width:3%;">
                        <mat-checkbox
                          (click)="$event.stopPropagation()"
                          (change)="checkVal($event, row)"
                          [checked]="selection.isSelected(row)"
                        >
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="ApplicationID">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef style="width:15%;">
                        Application ID @if (!appIdFilterApplied) {
                        <span
                          (click)="filterDropdown('ApplicationID'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                        </span>
                        } @if (appIdFilterApplied) {
                        <span
                          (click)="filterDropdown('ApplicationID'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                        </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let app" style="width:15%;">{{ app.ApplicationID }}</td>
                    </ng-container>
                    <ng-container matColumnDef="ApplicationName">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 30%;">
                        Application Name @if (!appNameFilterApplied) {
                        <span
                          (click)="filterDropdown('ApplicationName'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                        </span>
                        } @if (appNameFilterApplied) {
                        <span
                          (click)="filterDropdown('ApplicationName'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                        </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let app" style="width:30%;">{{ app.ApplicationName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="Category">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef style="width:15%;">
                        Category @if (!categoryFilterApplied) {
                        <span
                          (click)="filterDropdown('Category'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                        </span>
                        } @if (categoryFilterApplied) {
                        <span
                          (click)="filterDropdown('Category'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                        </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let app" style="width:15%;">{{ app.Category }}</td>
                    </ng-container>
                    <ng-container matColumnDef="App_Lifecycle_Status">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%;">
                        App Lifecycle Status @if (!appLifecycleFilterApplied) {
                        <span
                          (click)="filterDropdown('App_Lifecycle_Status'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                        </span>
                        } @if (appLifecycleFilterApplied) {
                        <span
                          (click)="filterDropdown('App_Lifecycle_Status'); $event.stopPropagation()"
                          [matMenuTriggerFor]="contextMenu"
                          #trigger="matMenuTrigger"
                        >
                          <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                        </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let app" style="width:15%;">{{ app.App_Lifecycle_Status }}</td>
                    </ng-container>
                    <ng-container matColumnDef="reset_filter">
                      <th mat-header-cell *matHeaderCellDef>
                        &nbsp; &nbsp; @if ((appIdFilterApplied || appNameFilterApplied || categoryFilterApplied ||
                        appLifecycleFilterApplied)) {
                        <span (click)="clearallFilter()">
                          <i
                            title="Reset Filters"
                            class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                          ></i>
                        </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let element"></td>
                    </ng-container>
                    <mat-menu #contextMenu="matMenu">
                      <div
                        class="menu-filter-popup"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()"
                      >
                        <input
                          matInput
                          type="text"
                          class="searchoption"
                          (keydown)="$event.stopPropagation()"
                          class="form-control filter-search-bar"
                          [(ngModel)]="searchTxt"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Search"
                        />
                        <mat-selection-list
                          class="filter-list-container"
                          (selectionChange)="selectionChange($event)"
                          [disableRipple]="true"
                          [(ngModel)]="filValue"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          @for (row of filterLists | search : searchTxt; track row) {
                          <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
                          }
                        </mat-selection-list>
                        <span
                          style="cursor:pointer; float: right;padding-right: 70px;"
                          class="small localApplyButton"
                          (click)="applyLocalFilter()"
                          >Apply</span
                        >
                        <span
                          style="cursor:pointer; float: right;padding-right: 22px;"
                          class="small localApplyButton"
                          (click)="clearLocalFilter()"
                          >Clear</span
                        >
                      </div>
                    </mat-menu>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>

                  <mat-paginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                    aria-label="Select page of periodic elements"
                  >
                  </mat-paginator>
                </div>
              </mat-tab>
              } @if (((visibility=='Private' && groupType=='Platform') ||groupType=='Custom') || showOnlyShareTab) {
              <mat-tab label="Manage Sharing">
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex form-edit-group-manage-share"
                >
                  <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
                    <p style="color: #013b71;font-weight: bold;">Share with users:</p>
                    <mat-select
                      multiple
                      name="groupperson"
                      [ngModelOptions]="{ standalone: true }"
                      (keydown)="$event.stopPropagation()"
                      panelClass="overlay-width-search-user"
                      [(ngModel)]="selectedPersons"
                      class="form-control"
                      placeholder="Search by Name/Mail (min 4 chars)"
                    >
                      <input
                        [ngModelOptions]="{ standalone: true }"
                        (keyup)="loadPeople()"
                        name="appsearch"
                        type="text"
                        class="form-control"
                        [(ngModel)]="msfilter"
                      />
                      <mat-option [ngValue]="undefined" hidden></mat-option>
                      @for (row of people; track row) {
                      <mat-option
                        class="edit-group-mat-option"
                        [disabled]="row.disable"
                        (click)="getPeopleData(row)"
                        title="{{ row.msid }}"
                        [value]="row.mail"
                      >
                        {{ row.cn }}<{{ row.givenName }}>({{ row.mail }})
                      </mat-option>
                      }
                    </mat-select>
                  </div>
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                    <button
                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                      mat-mdc-raised-button
                      style="margin-top: 17.38%;"
                      [disabled]="disableShare"
                      (click)="update_group(f)"
                    >
                      Share
                    </button>
                  </div>
                </div>
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex form-edit-group-manage-search"
                >
                  <ng-container>
                    <div class="table-search col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5 offset-md-5">
                      <mat-form-field class="data-filter" appearance="outline">
                        <input
                          matInput
                          type="text"
                          class="capability-search"
                          placeholder="Search User"
                          (keyup)="searchUsersDataSet($event)"
                        />
                        <img
                          src="../../../../assets/images/searchicon.png"
                          style="position: absolute;
                                                    right: 0px;
                                                    top: 20%;width:1.2rem"
                        />
                      </mat-form-field>
                    </div>
                    <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                      <ng-container>
                        <button
                          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                          mat-mdc-raised-button
                          style="margin-top: -49.12%"
                          [disabled]="disableRevoke"
                          (click)="removegroupuser()"
                        >
                          Revoke Access
                        </button>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div class="row"></div>
                <div class="container">
                  <table mat-table [(dataSource)]="dataSourceSharing" class="mat-elevation-z8">
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef style="width:3%;">
                        <mat-checkbox
                          (change)="$event ? mastershareToggle() : null"
                          [checked]="selectionSharing.hasValue() && isAllshareSelected()"
                          [indeterminate]="selectionSharing.hasValue() && !isAllshareSelected()"
                        >
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let row" style="width:3%;">
                        <mat-checkbox
                          (click)="$event.stopPropagation()"
                          (change)="checkShareVal($event, row)"
                          [checked]="selectionSharing.isSelected(row)"
                        >
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="userDetails">
                      <th mat-header-cell *matHeaderCellDef style="width:97%;">User Details</th>
                      <td mat-cell *matCellDef="let user" style="width:97%;">{{ user.userDetails }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnSharing"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnSharing"></tr>
                  </table>

                  <mat-paginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                    aria-label="Select page of periodic elements"
                  >
                  </mat-paginator>
                </div>
              </mat-tab>
              } @if (groupType!=='Custom' && !showOnlyShareTab) {
              <mat-tab label="Manage Delegate">
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex form-edit-group-manage-share"
                >
                  <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
                    <p style="color: #013b71;font-weight: bold;">Delegate to users:</p>
                    <mat-select
                      multiple
                      name="groupperson"
                      [ngModelOptions]="{ standalone: true }"
                      (keydown)="$event.stopPropagation()"
                      panelClass="overlay-width-search-user"
                      [(ngModel)]="selectedDelegatePersons"
                      class="form-control"
                      placeholder="Search by Name/Mail (min 4 chars)"
                    >
                      <input
                        [ngModelOptions]="{ standalone: true }"
                        (keyup)="loadDelegatePeople()"
                        name="appsearchsel"
                        type="text"
                        class="form-control"
                        [(ngModel)]="msfilter1"
                      />
                      <mat-option [ngValue]="undefined" hidden></mat-option>
                      @for (row of peopleDelegate; track row) {
                      <mat-option
                        class="edit-group-mat-option"
                        [disabled]="row.disable"
                        (click)="getDelegateData(row)"
                        title="{{ row.msid }}"
                        [value]="row.mail"
                      >
                        {{ row.cn }}<{{ row.givenName }}>({{ row.mail }})
                      </mat-option>
                      }
                    </mat-select>
                  </div>
                  <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                    <button
                      [disabled]="!(isGroupOwner || isDelegate) || disableDelegateAdd"
                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                      mat-mdc-raised-button
                      style="margin-top: 17.39%;"
                      (click)="delegate()"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div
                  class="row col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 form-check-inline d-inline-flex form-edit-group-manage-search"
                >
                  <ng-container>
                    <div class="table-search col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5 offset-md-5">
                      <mat-form-field class="data-filter" appearance="outline">
                        <input
                          matInput
                          type="text"
                          class="capability-search"
                          placeholder="Search User"
                          (keyup)="searchDelegateUsersDataSet($event)"
                        />
                        <img
                          src="../../../../assets/images/searchicon.png"
                          style="position: absolute;
                                                    right: 0px;
                                                    top: 20%;width:1.2rem"
                        />
                      </mat-form-field>
                    </div>
                    <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                      <ng-container>
                        <button
                          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                          mat-mdc-raised-button
                          style="margin-top: -49.12%;"
                          [disabled]="disableDelegateRevoke || !(isGroupOwner || isDelegate)"
                          (click)="removegroupDelegateuser()"
                        >
                          Revoke Access
                        </button>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div class="row"></div>
                <div class="container">
                  <table mat-table [(dataSource)]="dataSourceDelegate" class="mat-elevation-z8">
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef style="width:3%;">
                        <mat-checkbox
                          (change)="$event ? masterDelegateToggle() : null"
                          [checked]="selectionDelegate.hasValue() && isAllDelegateUsersSelected()"
                          [indeterminate]="selectionDelegate.hasValue() && !isAllDelegateUsersSelected()"
                        >
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let row" style="width:3%;">
                        <mat-checkbox
                          (click)="$event.stopPropagation()"
                          (change)="checkDelegateVal($event, row)"
                          [checked]="selectionDelegate.isSelected(row)"
                        >
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="delegateUserDetails">
                      <th mat-header-cell *matHeaderCellDef style="width:97%;">User Details</th>
                      <td mat-cell *matCellDef="let user" style="width:97%;">{{ user.delegateUserDetails }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnDelegate"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnDelegate"></tr>
                  </table>

                  <mat-paginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                    aria-label="Select page of periodic elements"
                  >
                  </mat-paginator>
                </div>
              </mat-tab>
              }
            </mat-tab-group>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="hover_bkgr_fricc" (click)="hidepopup()">
    <span class="helper"></span>
    <div
      style="background: #fff;
    text-align: left;
    overflow-y: scroll;
    height: 500px;"
    >
      <div class="popupCloseButton" (click)="hidepopup()">&times;</div>
      <p><strong>a. Create and Edit page for Admins: </strong></p>

      <p>· App Group Type can either be Platform or Custom, Visibility can either be Public or Private</p>

      <p>· If App Group Type is Platform, Visibility can be Public or Private</p>

      <p>· If App Group Type is Platform and Visibility is Public, it will not have a share Option</p>

      <p>
        · If App Group Type is Platform and Visibility is Private, it will have a share Option and limited to 9 users
        other than author.
      </p>

      <p>· If the Admin is not The App Group Owner, Share and transfer should not be available</p>

      <p>
        · If App Group Type is Custom, Visibility can only be Private and can be shared with 9 users other than author.
      </p>

      <p><strong>b. Create and Edit page for Non-Admin Users: </strong></p>

      <p>· App Group Type can only be Custom and Visibility Private.</p>

      <p>· Owner of the App Group will have Edit, Share, Transfer, View icons</p>

      <p>· User with who the App Group is shared with can only see View icon</p>

      <p>· Deleting a Group will only be allowed to the App Group Owner</p>

      <p><strong>c. Select By option: </strong></p>

      <p>
        · When "selected by" value is "LOB" and if value in LOB and Sub-LOB is blank, then show all the applications
        under "Application" drop down.
      </p>

      <p>
        · When "selected by" value is "LOB" and if value in LOB and/or Sub-LOB is selected, then show only the filtered
        applications based on selected LOB/Sub-LOB.
      </p>

      <p>
        · When "selected by" value is "Tech Owner" and if value in Tech Owner is blank, then show all the applications
        under "Application" drop down.
      </p>

      <p>
        · When "selected by" value is "Tech Owner" and if value in Tech Owner is selected, then show only the filtered
        applications based on selected Tech Owner.
      </p>

      <p>
        · When "selected by" value is "SLO" and if value in SLO is blank, then show all the applications under
        "Application" drop down.
      </p>

      <p>
        · When "selected by" value is " SLO " and if value in SLO is selected, then show only the filtered applications
        based on selected SLO.
      </p>

      <p><strong>d. Export to Excel </strong></p>

      <p>· Should contain all the details that shown in View Details screen</p>

      <p><strong>e. All existing Groups are defaulted to App Group Type “Custom” and Visibility “Private”</strong></p>

      <p><strong> Edit application group</strong></p>

      <p><strong>f. Manage sharing tab will be visible on if the Visibility is “Private” </strong></p>
    </div>
  </div>
</div>
